import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddToDashboardModal from '../Dashboard/AddToDashboardModal';
import './AddToDashboardButton.css';

/**
 * Button to add current query to a dashboard
 * @param {Object} props - Component props
 * @param {number} props.queryId - ID of the query to add
 * @param {string} props.currentChartType - Currently selected chart type
 * @param {boolean} props.disabled - Whether button is disabled
 * @returns {JSX.Element} Button component
 */
const AddToDashboardButton = ({ queryId, currentChartType, disabled }) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleClick = () => {
    setIsModalOpen(true);
  };

  const handleClose = (success) => {
    setIsModalOpen(false);
    if (success) {
      // Show success message briefly
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
    }
  };

  return (
    <>
      <div className="add-to-dashboard-container">
        <button
          className="add-to-dashboard-btn"
          onClick={handleClick}
          disabled={disabled}
          title={t('dashboards.addToDashboard')}
          aria-label={t('dashboards.addToDashboard')}
        >
          <img src="/dashboard_icon.svg" alt="" />
        </button>

        {showSuccess && (
          <div className="success-message">
            ✓ {t('dashboards.addedSuccessfully')}
          </div>
        )}
      </div>

      <AddToDashboardModal
        isOpen={isModalOpen}
        onClose={handleClose}
        queryId={queryId}
        currentChartType={currentChartType}
      />
    </>
  );
};

export default AddToDashboardButton;

